import { Checkbox } from "antd";
import React, { useEffect, useState } from "react";

const Checkbox_v2 = (props) => {
  const { label, handleChange, checkValue, size,key, className = "", isDisabled = false,passFullEvent = false} = props;

  const [ischecked, setIsChecked] = useState(checkValue || false);

  const handlecheck = (e) => {
    const checked = e.target.checked;
    setIsChecked(checked);
   
    if (passFullEvent) {
      handleChange(e);  // Pass the full event if `passFullEvent` is true
    } else {
      handleChange(checked);  // Pass only `checked` if `passFullEvent` is false
    }
  };

  useEffect(()=> {
    if(ischecked !== checkValue){
      setIsChecked(checkValue)
    }

  }, [checkValue])

  return (
    <div className="checkbox_v2">
      <Checkbox
      key={key}
        checked={checkValue}
        className={className}
        size={size}
        onChange={handlecheck}
        disabled={isDisabled}
      >
        {ischecked == true ? <strong>{label}</strong> : <span>{label}</span>}
      </Checkbox>
    </div>
  );
};

Checkbox_v2.defaultProps = {
  label: "",
  size: "small",
  handleChange: () => {},
  passFullEvent: false 
};

export default Checkbox_v2;
